export class ErrorMessageConstants {
    public static readonly MissingData: string = "[missing data]";
}